import React from 'react';
import { SelectInput } from './SelectInput';

interface PercentageSelectProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  width?: string;
  customTestId?: string;
}

const PERCENTAGE_OPTIONS = [
  { value: '0', option: '0%' },
  { value: '10', option: '10%' },
  { value: '20', option: '20%' },
  { value: '30', option: '30%' },
  { value: '40', option: '40%' },
  { value: '50', option: '50%' },
  { value: '60', option: '60%' },
  { value: '70', option: '70%' },
  { value: '80', option: '80%' },
  { value: '90', option: '90%' },
  { value: '100', option: '100%' },
];

export const PercentageSelect: React.FC<PercentageSelectProps> = ({
  label,
  value,
  onChange,
  width = 'w-1/2',
  customTestId,
}) => {
  return (
    <SelectInput
      label={label}
      value={value}
      onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
        onChange(e.target.value)
      }
      valuesAndOptions={PERCENTAGE_OPTIONS}
      width={width}
      custom_test_id={customTestId}
    />
  );
};
